<template>
    <div>
        <div style="border-bottom: 1px solid #eee;padding: 10px 0 20px 0;margin-bottom: 20px;">
            <el-checkbox v-model="form3.weizuojiancha">未做相关检测</el-checkbox>
        </div>
        <div class="aml"
             v-if="showAML">
            <div class="caption">AML</div>
            <el-checkbox-group v-model="form3.aml"
                               :class="$store.state.registration.form9.indexOf('form3_aml') >= 0?'container':''"
                               :disabled="form3.weizuojiancha">
                <el-row>
                    <el-col :span="8">
                        <el-checkbox @change="handlaml" label="正常核型"></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                单体核型是指存在两个或以上染色体单体（X或Y染色体缺失除外），<br/>
                                或一个染色体单体同时伴有至少一个额外的染色体结构异常<br/>
                                （t(8;21)、inv(16)或t(16;16)、t(15;17)除外）
                            </div>
                            <el-checkbox label="单体核型" :disabled='amll'></el-checkbox>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                * 其中,复杂核型不伴有 t(8;21)(q22;q22) ,<br/>
                                 inv(16)(p13q22) 或  t(16;16)(p13;q22) <br/>
                                或 t(15;17)(q22;q12)"
                            </div>
                            <el-checkbox label="复杂核型（≥3种）" :disabled='amll'>
                                复杂核型（≥3种）
                            </el-checkbox>
                        </el-tooltip>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="t(8;21) (q22;q22)" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="inv(16)(p13q22)或t(16;16)(p13;q22)" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="t(15;17) (q24;q21)" :disabled='amll'></el-checkbox>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="t(9;22)(q34.1;q11.2)" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="t(9;11)(p21;q23)" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="除t(9;11)外的11q23染色体易位" :disabled='amll'></el-checkbox>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="-5/5q-" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="-7/7q-" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="-17/abn(17p)" :disabled='amll'></el-checkbox>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="inv(3)(p21p26)或t(3;3)(q21;q26)" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="t(6;9)(p22;q34)" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="11q-/del(11q)" :disabled='amll'></el-checkbox>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="12p-/del(12p)" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="-13/13q-/del(13p)" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="idic(X)(q13)" :disabled='amll'></el-checkbox>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="不详" :disabled='amll'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="其他"> 其他
                            <el-input v-model="form3.aml_qita" :class="$store.state.registration.form9.indexOf('form3_aml_qita') >= 0?'container':''"
                                      :disabled="form3.aml.indexOf('其他') == -1"
                                      placeholder="请输入内容"></el-input>
                        </el-checkbox>
                    </el-col>
                </el-row>
            </el-checkbox-group>
        </div>
        <div class="all"
             v-if="showALL">
            <div class="caption">ALL</div>
            <el-checkbox-group v-model="form3.all"
                               :class="$store.state.registration.form9.indexOf('form3_all') >= 0?'container':''"
                               :disabled="form3.weizuojiancha">
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="正常核型" @change="handlall"></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                指出现五个或更多的染色体异常
                            </div>
                            <el-checkbox label="复杂核型（≥5种）" :disabled='qall'></el-checkbox>
                        </el-tooltip>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                指染色体数目增多至51-65
                            </div>
                            <el-checkbox label="高二倍体（51-65）" :disabled='qall'></el-checkbox>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                指染色体数目增多至60-78
                            </div>
                            <el-checkbox label="近三倍体（60-78）" :disabled='qall'></el-checkbox>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                指有染色体缺失，致染色体数目为30-39。近三倍体、近单倍体常会并存于同一病例，可复选
                            </div>
                            <el-checkbox label="近单倍体（30-39）" :disabled='qall'></el-checkbox>
                        </el-tooltip>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="t(9;22)(q34.1;q11.2)" :disabled='qall'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="t(12;21)(p13;q22)" :disabled='qall'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                指涉及11q23的染色体易位
                            </div>
                            <el-checkbox label="t(v;11q23)" :disabled='qall'></el-checkbox>
                        </el-tooltip>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="t(1;19)(q23;p13)" :disabled='qall'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="t(5;14)(q35;q32)" :disabled='qall'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                指21号染色体内部扩增
                            </div>
                            <el-checkbox label="iamp21" :disabled='qall'></el-checkbox>
                        </el-tooltip>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="t(17;19)(q22;p13)/TCF3::HLF" :disabled='qall'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="亚二倍体(染色体数目<44)" :disabled='qall'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="item"
                                    placement="top-start">
                            <div slot="content">
                                指21号染色体内部扩增
                            </div>
                            <el-checkbox label="iamp21" :disabled='qall'></el-checkbox>
                        </el-tooltip>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-checkbox label="不详" :disabled='qall'></el-checkbox>
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox label="其他"> 其他
                            <el-input v-model="form3.all_qita"   :class="$store.state.registration.form9.indexOf('form3_all_qita') >= 0?'container':''"
                                      :disabled="form3.all.indexOf('其他') == -1"
                                      placeholder="请输入内容"></el-input>
                        </el-checkbox>
                    </el-col>
                </el-row>
            </el-checkbox-group>
        </div>
        <div style="border-top: 1px solid #eee;padding-top:20px;margin-top:40px">
            <el-row>
                <el-col :span="4">
                    <el-dialog title="预览"
                               :visible.sync="dialogVisible" append-to-body
                               height="70%">
                        <div>
                            <img :src="imageUrl"
                                 width="100%;" :style="{transform:'rotateZ('+deg+'deg)'}">
                        </div>
                        <span slot="footer"
                              class="dialog-footer">
                              <el-button type="info" @click="rotate">旋 转</el-button>
                              <el-button type="primary"
                                         @click="dialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>
                    <el-form-item label=""
                                  label-width="20px"
                                  prop="fileList">
                        <el-upload class="upload-demo"
                                   action="/api/case/upload/"
                                   :headers="uploadHeader"
                                   ref="uploaddemo"
                                   :onSuccess="uploadSuccess"
                                   :on-preview="handlePreview"
                                   :on-remove="handleRemove"
                                   :before-remove="beforeRemove"
                                   :file-list="form3.baogaotupian">

                            <el-button type="primary">▲报告图片上传</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label-width="0px">
                        <el-button type="primary" @click="wmcode('xibaoyichuan_baogaotupian')">▲扫二维码上传</el-button>
                        <!-- <el-button @click="getimage('xibaoyichuan_baogaotupian')"> -->
                        <!-- <i class="el-icon-refresh"></i> -->
                        <!-- </el-button> -->
                        <!-- <erweima  :url="url" v-if="rwcode"/> -->
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
        <el-dialog
                title="扫二维码上传"
                :visible.sync="model"
                width="30%"
                :before-close="handleQrcode">
            <erweima id="xibyc" ref="xibyc"/>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleQrcode">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import erweima from './widgets/erweima'

    export default {
        props: ['addedit'],
        components: {
            erweima
        },
        data() {
            let token = localStorage.getItem('token')
            return {
                deg: 0,
                model: false,
                amll: false,
                qall: false,
                form3: this.$store.state.registration.form3,
                uploadHeader: {Authorization: `Bearer ${token}`},
                dialogVisible: false,
                imageUrl: '',
            }
        },
        computed: {
            showAML() {
                var that = this
                var form = this.$store.state.registration.form3
                that.amll = false
                if (form.aml && form.aml[0] == '正常核型') {
                    that.amll = true
                }
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === '急性双表型白血病') return true
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === '不详') return true
                return this.$store.state.registration.form2.zhenduanfenxing[0] === 'AML'
            },
            showALL() {
                var that = this
                var form = this.$store.state.registration.form3
                that.qall = false
                if (form.all && form.all[0] == '正常核型') {
                    that.qall = true
                }
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === '急性双表型白血病') return true
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === '不详') return true
                return this.$store.state.registration.form2.zhenduanfenxing[0] === 'ALL'
            }
        },
        methods: {
            rotate() {
                this.deg += 90;
                if (this.deg >= 360) {
                    this.deg = 0
                }
            },
            handleQrcode() {
                this.model = false
                this.getimage('xibaoyichuan_baogaotupian')
            },
            handlaml(v) {
                this.amll = v
                if (v) {
                    this.form3.aml = ['正常核型']
                }
            },
            handlall(v) {
                this.qall = v
                if (v) {
                    this.form3.all = ['正常核型']
                }
            },
            quchong(data) {
                var b = []
                var tem = data.concat(this.form3.baogaotupian);
                var len = tem.length;
                var i = 0;
                var arr = [];
                for (; i < len; i++) {
                    var t = tem[i];
                    if (arr.indexOf(t['id']) == -1) {
                        arr.push(t['id']);
                        b.push(t);
                    }

                }
                return b
            },
            getimage(value) {
                this.$http.get(`/case/image/list/?filed=${value}&uid=${this.$store.state.registration.form1.uuid}`)
                    .then(resp => {
                        this.form3.baogaotupian = this.quchong(resp.data.data)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            },
            guid() {
                var that = this
                return (that.S4() + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + that.S4() + that.S4());
            },
            wmcode(value) {
                var that = this
                that.model = true
                if (!that.$store.state.registration.form1.uuid) {
                    that.$store.state.registration.form1.uuid = that.guid()
                }
                if (that.$store.state.registration.form1.uuid) {
                    var url = window.location.href.split('#')[0] + 'case/uploadsredoce/?field='
                    url = url + value + '&uuid=' + that.$store.state.registration.form1.uuid+ "&token=" + localStorage.getItem('token')
                    that.$nextTick(() => {
                        that.$refs.xibyc.useqrcode(url)
                    })
                } else {
                    that.$message({
                        message: '请先暂存数据，再刷新页面',
                        type: 'warning'
                    })
                }
            },
            handlePreview(e) {
                console.log(e)
                var name = e.url.split('.').pop()
                if (name == "pdf") {
                    window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
                } else if (name == "png" || name == "jpeg" || name == "bmp" || name == "jpg") {
                    // this.dialogVisible = true
                    // this.imageUrl = e.url
                    window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
                } else {
                    window.location = window.location.href.split('#')[0] + e.url.slice(1)
                }
            },
            handleRemove(file, fileList) {
                this.$store.state.registration.form3.baogaotupian = fileList;
                this.$store.dispatch({
                    type: 'delImage',
                    pk: file.id,

                }).then(resp => {
                    if (resp.data.code == 1) {
                        this.$message({message: '删除成功！', type: 'success'})
                    } else if (resp.data.code == -1) {
                        this.$message({message: resp.data.errors, type: 'error'})
                    }
                });
            },
            uploadSuccess(response, file) {
                console.log('上传文件', file)
                this.$store.state.registration.form3.baogaotupian.push(file.response)

            },
            setAml() {
                this.qall = false
                this.amll = false
            }
        },
        watch: {
            "$route": "setAml"
        },
        mounted() {
            if (this.addedit == 0) {
                this.$store.state.registration.form3.baogaotupian = []
                this.$refs.uploaddemo.clearFiles();
            }
        }
    };
</script>

<style scoped>
    .el-row {
        margin: 20px 0;
    }

    .el-checkbox__input {
        vertical-align: top;
    }

    .form /deep/ .el-checkbox__label {
        font-size: 13px;
    }

    .container /deep/ .el-checkbox__inner {
        border: 1px solid red;
    }
</style>
